export default {
  HAS_REGISTERED: 'hasRegistered',
  ACCESS_CODE: 'accessCode',
  COMPANY_DETAILS: 'companyDetails',
  AUDIENCE_TYPE: 'audienceType'
};
